// Module
var code = `<div>

  <div class="filters">
    <span class="labelled-field">
      <label class="add-on">Mapping name</label>
      <input type="text" class="filter-value" ng-model="\$ctrl.filter.templateName">
    </span>
  </div>

  <div>
    <table ng-table="\$ctrl.tableConfig"  class="table">
      <tr ng-repeat="unit in \$data">
        <td data-title="'No'">{{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}</td>
        <td data-title="'Mapping name'">{{ unit.templateName | replaceWithInvoice}}</td>
        <td data-title="'Entry type'">{{ unit.entryType | prettyEnum }}</td>
        <td data-title="'Branch type'">{{ unit.branchType | prettyEnum }}</td>
        <td data-title="'Delegate'">
          <input
              type="checkbox"
              ng-model="unit.delegate"
              ng-change="\$ctrl.onDelegateChange(unit)" />
        </td>
        <td data-title="'Tag'">
          <selectize
              ng-disabled="!unit.delegate"
              options="\$ctrl.tags"
              ng-required="unit.delegate"
              config="\$ctrl.selectConfig"
              ng-model="unit.tagType">
          </selectize>
          {{ unit.delegateTagType | prettyEnum }}
        </td>
        <td data-title="'GL Account'">
          <div ng-if="unit.delegate">
            <selectize
                ng-disabled="unit.delegate"
                ng-model="\$ctrl.devnull"
                config="\$ctrl.emptyAccountConfig"
                options="[]">
            </selectize>
          </div>
          <div ng-if="!unit.delegate">
            <field
                options="\$ctrl.ledgerAccounts"
                field="fullCode"
                ng-model="unit.accountFullCode"
                transcluded-model="unit.tmpAccountFullCode"
            >
              <account-select options="\$ctrl.ledgerAccounts"
                              ng-model="unit.tmpAccountFullCode"
                              value-field="'id'"
                              ng-required="!unit.delegate">
              </account-select>
            </field>
          </div>
        </td>
        <td>
          <div class="summary-actions">
            <button
                type="button"
                class="btn btn-primary"
                ng-click="\$ctrl.saveUnit(unit)">
              Save
            </button>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/general-ledger/misc-transaction-mapping/misc-transaction-mapping.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;